import { render, staticRenderFns } from "./TrialList.vue?vue&type=template&id=0bc442f6&scoped=true&"
import script from "./TrialList.vue?vue&type=script&lang=js&"
export * from "./TrialList.vue?vue&type=script&lang=js&"
import style0 from "./TrialList.vue?vue&type=style&index=0&id=0bc442f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc442f6",
  null
  
)

export default component.exports